<template lang="pug">
VList(
  tag="ol"
  :nav="true"
)
  VListItem(
    v-for="(note, index) in notes"
    :id="note.noteId"
    :key="index"
    tag="li"
  )
    template(#prepend)
      VBtn(
        :href="`#${note.supId}`"
        :icon="true"
        variant="flat"
        tag="a"
        size="small"
        :title="i18n.t('TheComment.JumpBackText')"
        @click="emitClick(`#${note.supId}`, $event)"
      )
        span.section-title-2.ma-0 {{ index + 1 }}
    CommentNote(:note="note")
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { NoteData } from "./commentBody.util.notes";
import { scrollIfAnchor } from "~/units/browser";

const i18n = useI18n();

interface Props {
  notes: NoteData[];
}

const props = defineProps<Props>();

interface Emits {
  (e: "linkClicked"): void;
}

const emit = defineEmits<Emits>();

/**
 * Emit that a link has been clicked
 */
function emitClick(href: string, e: MouseEvent) {
  e.preventDefault();
  e.stopPropagation();
  scrollIfAnchor(href);
  emit("linkClicked");
}
</script>
